import { ElTable } from 'element-plus'

interface proximitySummaryColumnMapInterface {
  // カラム名: ソート用カラム名
  [columnName: string]: [
    headerLabel: string, // ヘッダーラベル表示部
    sortColumn: string, // ソート列指定
    updatedMsgType: string, // 最新メッセージ取得表示カラムに対応するメッセージ種別
    labelClass: string, // ヘッダーラベルクラス
    columnWidth: string, // カラム幅
    cellClass: string // 各セルに当てるクラス
  ]
}

export const proximitySummaryColumnKeyMap = Object.freeze({
  headerLabel: 0,
  sortColumn: 1,
  updatedMsgType: 2,
  labelClass: 3,
  columnWidth: 4,
  cellClass: 5,
})

export const proximitySummaryColumnMap: proximitySummaryColumnMapInterface = {
  disp_applicant_number: ['申請番号\n', 'disp_applicant_number', '', 'br-class', '80', ''],
  disp_department_name: ['保守区\n', 'department_sort', '', 'br-class', '70', ''],
  // 復数のグループヘッダーを含めて固定列に指定する際は、親のwidthは子ヘッダーの変則和を明示する必要あり
  // applicant_label => 事業者+担当者 width:250
  applicant_label: ['申請者', '', '', 'br-class', '210', ''],
  disp_applicant_business_name: ['事業者\n', 'disp_applicant_business_name', '', 'br-class', '140', ''],
  disp_applicant_manager_name: ['担当者\n', 'disp_applicant_manager_name', '', 'br-class', '70', ''],
  disp_line_name: ['線名\n', 'line_sort', '', 'br-class', '70', ''],
  // station_label => 担当者+駅間*2 width:270
  station_label: ['駅間', '', '', '', '210', ''],
  disp_start_station_name: ['', 'start_station_sort', '', '', '70', ''],
  disp_end_station_name: ['', 'end_station_sort', '', '', '70', ''],
  disp_meter: ['キロ程\n', 'for_filter_meter', '', 'br-class', '75', ''],
  disp_applicant_title: ['標題\n', 'disp_applicant_title', '', 'br-class', '130', ''],
  disp_construction_type: ['工事種別\n', 'construction_type', '', 'br-class', '80', ''],
  disp_applicant_date: ['申請日\n', 'applicant_time', '', 'br-class', '50', ''],
  plan_date_label: ['施工予定期間', '', '', '', '', ''],
  disp_start_plan_date: ['着手\n', 'start_plan_date', '', 'br-class', '50', ''],
  disp_end_plan_date: ['しゅん功\n', 'end_plan_date', '', 'br-class', '50', ''],
  disp_applicant_contact_date: ['問合わせ中\nJQ→申請者\n', 'applicant_contact_date', '', 'br-class', '50', ''],
  disp_judge_discussion_ask_date: ['要否判断伺\nJQ→JR\n', 'judge_discussion_ask_date', '101', 'br-class', '50', ''],
  judge_discussion_label: ['要否判断', '', '', 'header-featured-bk-color', '', ''],
  disp_judge_discussion_necessary_date: [
    '承認\n',
    'judge_discussion_necessary_date',
    '104,105',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  disp_judge_discussion_status: [
    '要否\n',
    'judge_discussion_status',
    '',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  disp_judge_discussion_unnecessary_notice_date: [
    '協議不要\n連絡\nJR→申請者\n',
    'judge_discussion_unnecessary_notice_date',
    '106',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  disp_prior_discussion_candidate_date: [
    '事前協議\n日程調整\n連絡\nJR→申請者\n',
    'prior_discussion_candidate_date',
    '201',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  prior_discussion_label: ['事前協議', '', '', '', '', ''],
  disp_prior_discussion_decide_date: [
    '日程連絡\nJQ→申請者\n',
    'prior_discussion_decide_date',
    '203',
    'br-class',
    '50',
    '',
  ],
  disp_prior_discussion_schedule_date: ['実施日\n', 'prior_discussion_schedule_time', '', 'br-class', '50', ''],
  disp_prior_discussion_schedule_time: ['開始時刻\n', 'prior_discussion_schedule_time', '', 'br-class', '50', ''],
  disp_prior_discussion_necessary: ['区分\n(有無済)\n', 'disp_prior_discussion_necessary', '', 'br-class', '50', ''],
  disp_prior_discussion_result_date: [
    '事前協議\n結果入力\n',
    'prior_discussion_date',
    '204',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  disp_discussion_document_request_date: [
    '協議書\n作成依頼\nJR→申請者\n',
    'discussion_document_request_date',
    '301',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  disp_discussion_document_request_confirm_date: [
    '協議書\n確認通知\nJQ→JR\n',
    'discussion_document_request_confirm_date',
    '302',
    'br-class',
    '50',
    '',
  ],
  disp_discussion_document_receipt_date: [
    '協議書\n受領連絡\nJR→申請者\n',
    'discussion_document_receipt_date',
    '304',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  disp_witness_schedule_jr_adjust_date: [
    '現地立会\nJR関係者\n日程調整\n連絡\n',
    'witness_schedule_jr_adjust_date',
    '401',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  disp_witness_schedule_adjust_date: [
    '現地立会\n日程調整\n連絡\nJQ→申請者',
    'witness_schedule_adjust_date',
    '403',
    'br-class',
    '50',
    '',
  ],
  witness_schedule_label: ['現地立会', '', '', '', '', ''],
  disp_witness_schedule_decide_date: [
    '日程連絡\nJQ→\nJR,申請者\n',
    'witness_schedule_decide_date',
    '405',
    'br-class',
    '50',
    '',
  ],
  disp_witness_schedule_date: ['実施日\n', 'witness_schedule_time', '', 'br-class', '50', ''],
  disp_witness_schedule_time: ['開始時刻\n', 'witness_schedule_time', '', 'br-class', '50', ''],
  disp_witness_schedule_necessary: ['区分\n(有無済)\n', 'disp_witness_schedule_necessary', '', 'br-class', '50', ''],
  disp_witness_schedule_result_date: [
    '現地立会\n結果入力\n',
    'witness_schedule_result_date',
    '407',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  disp_witness_schedule_opinion_date: ['意見照会\nJQ→JR', 'witness_schedule_opinion_date', '408', 'br-class', '50', ''],
  disp_witness_schedule_opinion_answer_date: [
    '意見照会\n回答完了\n',
    'disp_witness_schedule_opinion_answer_date',
    '409',
    'header-featured-bk-color br-class',
    '',
    'cell-featured-bk-color',
  ],
  disp_answer_ask_date: ['回答案伺\nJQ→JR\n', 'answer_ask_date', '501', 'br-class', '50', ''],
  disp_answer_pre_explain_date: [
    '回答案\n送付\nJR→申請者\n',
    'answer_pre_explain_date',
    '503',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  disp_answer_date: [
    '回答書\n送付\nJR→申請者\n',
    'answer_date',
    '504',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  disp_answer_receipt_notice_date: [
    '回答請書\n確認通知\nJQ→JR\n',
    'answer_receipt_notice_date',
    '506',
    'br-class',
    '50',
    '',
  ],
  disp_adversaria_request_date: [
    '覚書等\n作成依頼\nJQ→申請者\n',
    'adversaria_request_date',
    '601',
    'br-class',
    '50',
    '',
  ],
  disp_adversaria_send_date: [
    '覚書等\n送付\nJR→申請者',
    'adversaria_send_date',
    '604',
    'header-featured-bk-color br-class',
    '50',
    'cell-featured-bk-color',
  ],
  status_label: ['状態', '', '', 'header-status-bk-color', '', ''],
  disp_prior_discussion_status: [
    '事前協議\n',
    'prior_discussion_status',
    '',
    'header-status-bk-color br-class',
    '90',
    'cell-status-bk-color',
  ],
  disp_discussion_document_status: [
    '協議書\n',
    'discussion_document_status',
    '',
    'header-status-bk-color br-class',
    '90',
    'cell-status-bk-color',
  ],
  disp_witness_status: [
    '現地立会\n意見照会\n',
    'witness_status',
    '',
    'header-status-bk-color br-class',
    '90',
    'cell-status-bk-color',
  ],
  disp_answer_status: ['回答\n', 'answer_status', '', 'header-status-bk-color br-class', '90', 'cell-status-bk-color'],
  disp_adversaria_status: [
    '覚書等\n',
    'adversaria_status',
    '',
    'header-status-bk-color br-class',
    '90',
    'cell-status-bk-color',
  ],
}

/**
 * ソート対象取得
 * @param columnName string
 * @returns string
 */
export const getSortColumn = (columnName: string): string => {
  if (!(columnName in proximitySummaryColumnMap)) {
    return ''
  }
  return proximitySummaryColumnMap[columnName][proximitySummaryColumnKeyMap.sortColumn]
}

/**
 * マウスホバー時にハイライトしないスタイルを設定
 * @param rowInfo <typeof ElTable.cellStyle>
 * @returns string
 */
export const colorsCellStyle = (rowInfo: InstanceType<typeof ElTable.cellStyle>): string => {
  // 完了状態の行色設定
  if (rowInfo.row.status_column_color) {
    return 'background:' + rowInfo.row.status_column_color
  }
  return ''
}

/**
 * テーブルのセルにクラスを付与
 * @param rowInfo <typeof ElTable.cellStyle>
 * @returns string
 */
export const colorsCellClass = (rowInfo: InstanceType<typeof ElTable.cellClassName>): string => {
  let styleClass = ''
  const columnName = rowInfo.column.property

  // 完了状態の場合は処理をスキップ
  if (rowInfo.row.status_column_color) {
    return styleClass
  }

  // 最新更新セルの文字色変更
  const updatedMsgType: string | null = rowInfo.row.updated_message_type
  if (updatedMsgType) {
    if (
      proximitySummaryColumnMap[columnName][proximitySummaryColumnKeyMap.updatedMsgType].indexOf(updatedMsgType) !== -1
    ) {
      styleClass = 'updated-status-color'
    }
  }

  // 背景カラーを設定
  const bkColorClass = proximitySummaryColumnMap[columnName][proximitySummaryColumnKeyMap.cellClass]
  if (!bkColorClass) {
    return styleClass
  }
  return styleClass + ' ' + bkColorClass
}
